import React, { useMemo, useState } from "react";
import { Card, DataTable, hasActiveFilters } from "@sscs/ui";
import { getQueryStatus, sortItems } from "@sscs/utils";
import { EMPTY_PUBLISHER } from "../../../constants";
import { useReportDispatch, useReportSelector } from "../../hooks";
import { useGetComponentDependenciesQuery } from "../../services/fileBrowser.api";
import { filterUpdated, paginationUpdated, selectFilter, selectPagination, selectSort, sortUpdated, } from "../store/dependenciesSlice";
import { useGetFileAndReportId } from "../useGetFileAndReportId";
import Dependency from "./dependency/Dependency";
import Filter from "./filter/Filter";
import { filterDependencies, initFilter, specialCasesForSorting, } from "./utils";
const COLUMNS = [
    { id: "info", label: "Info", width: "70px" },
    {
        id: "cve",
        label: "CVE",
        sortProperty: "cve",
        sortId: "dependencies-sort-cve",
        startReverse: true,
        width: "100px",
    },
    { id: "linking", label: "Linking type", width: "125px" },
    {
        id: "name",
        label: "Name and version",
        sortProperty: "dependency_name",
        sortId: "dependencies-sort-name",
        width: "100%",
        minWidth: "170px",
    },
    {
        id: "publisher",
        label: "Publisher",
        sortProperty: "publisher",
        sortId: "dependencies-sort-publisher",
        width: "100%",
    },
    {
        id: "license",
        label: "License",
        sortProperty: "license",
        sortId: "dependencies-sort-license",
        width: "100%",
    },
    {
        id: "threat",
        label: "Threat name",
        sortProperty: "threat_name",
        sortId: "dependencies-sort-threat-name",
        width: "300px",
    },
];
const Dependencies = () => {
    const dispatch = useReportDispatch();
    const { fileId, reportId } = useGetFileAndReportId();
    const { data = { dependencies: [] }, isLoading, isFetching, isError, error, } = useGetComponentDependenciesQuery({
        reportId: reportId,
        fileId: fileId !== null && fileId !== void 0 ? fileId : "",
    });
    const filter = useReportSelector(selectFilter);
    const sort = useReportSelector(selectSort);
    const pagination = useReportSelector(selectPagination);
    const [focusedRow, setFocusedRow] = useState(null);
    const publishers = useMemo(() => Array.from(new Set(data.dependencies.map((dependency) => dependency.identity.publisher
        ? dependency.identity.publisher
        : EMPTY_PUBLISHER))).sort(), [data.dependencies]);
    const filteredData = useMemo(() => filterDependencies(data.dependencies, filter), [data.dependencies, filter]);
    const sortedData = useMemo(() => {
        return sortItems(filteredData, sort, specialCasesForSorting);
    }, [filteredData, sort]);
    const paginatedData = useMemo(() => {
        return sortedData.slice((pagination.currentPage - 1) * pagination.itemsPerPage, pagination.currentPage * pagination.itemsPerPage);
    }, [sortedData, pagination]);
    const handleSortChange = (sort) => {
        dispatch(sortUpdated(sort));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Card.Filters, { found: {
                id: "dependencies-clear-all-filters",
                count: sortedData.length,
                initialFilters: initFilter,
                activeFilters: filter,
                onClear: () => dispatch(filterUpdated(initFilter)),
            } },
            React.createElement(Filter, { filter: filter, publishers: publishers, onChange: (filter) => dispatch(filterUpdated(filter)) })),
        React.createElement(DataTable, { chrome: "plain", columns: COLUMNS, sort: sort, onSortChange: handleSortChange, empty: {
                subject: "dependencies",
                filters: {
                    active: hasActiveFilters(initFilter, filter),
                    onReset: () => dispatch(filterUpdated(initFilter)),
                },
            }, status: getQueryStatus({
                data,
                isLoading,
                isFetching,
                isError,
                error,
            }), pagination: {
                id: "dependencies-pagination",
                itemCount: sortedData.length,
                pagination,
                onChange: (pagination) => dispatch(paginationUpdated(pagination)),
            } }, paginatedData.map((dependency, index) => (React.createElement(Dependency, { key: dependency.identity.uuid, dependency: dependency, filter: filter, focused: dependency.identity.uuid === focusedRow, rowIndex: index, onClick: () => setFocusedRow(dependency.identity.uuid) }))))));
};
export default Dependencies;
//# sourceMappingURL=Dependencies.js.map